import { useNavigation } from '@react-navigation/native';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { View, StyleSheet, TouchableOpacity, Image, ScrollView, Linking } from 'react-native';

import { useDispatch, useSelector } from 'react-redux';
import BaseText from '../../components/BaseText';
import Button from '../../components/Button';
import CheckboxSquare from '../../components/CheckboxSquare';
import Icon from '../../components/Icon';

import RowView from '../../components/RowView';
import SearchTypeCheckbox from '../../components/TripSearchWidget/SearchTypeCheckbox';
import TripSearchWidgetRebook from '../../components/TripSearchWidget/TripSearchWidgetRebook';
import TripSearchWidget, {
  TripSearchForm,
} from '../../components/TripSearchWidget/TripSearchWidget';
import { Modals, Screens } from '../../constants/ScreenNames';
import { i18nNS, useComponentTKey } from '../../i18n';
import { getRebookPassengers } from '../../services/api/mytrips.service';
import { openAlert } from '../../store/actions/alert';
import { uncheckRebookPassengers, checkRebookPassengers } from '../../store/actions/mytrips';
import { setSearchInput, tripSearch } from '../../store/actions/search';
import { selectRebookPassengers } from '../../store/selectors/mytrips.selector';
import { CommonProperties, CommonStyles, Color, FontSize } from '../../styles';
import { validateTripSearch } from '../../utils/search.utils';
import useTripSearchWidget from '../../utils/useTripSearchWidget';
import RebookFooter from '../../components/RebookFooter';

export const RebookHomeContext = React.createContext();
const RebookHomeScreen = () => {
  const [checkedPassengers, setChecked] = React.useState([]);

  const passengers = useSelector(selectRebookPassengers);
  const searchTripLoading = useSelector((s) => s.search.tripResultsLoading);
  const { t } = useTranslation(i18nNS.login);
  const { tKey } = useComponentTKey('LoginScreen');
  const navigation = useNavigation();
  const dispatch = useDispatch();
  //console.log({ checked });

  useEffect(() => {
    //check the passenger on page load
    setChecked(passengers);
  }, []);

  const handleCheckbox = (e, passenger) => {
    if (e) {
      dispatch(checkRebookPassengers(passenger));
    } else {
      dispatch(uncheckRebookPassengers(passenger));
    }
    const newPassengers = passengers.filter((passenger) => passenger.isCheck === true);
    console.log(newPassengers.length);
    setChecked(newPassengers);
  };

  const newState = {
    hasAir: true,
    hasHotel: false,
    hasCar: false,
    hasRail: false,
    dominantSearchType: 'air',
    subSearchType: 'oneway',
    // searchCriteria: finalCriteria,
    enableSearchTypeSelector: false,
    enablePassengerClass: false,
  };

  const onSearch = (params) => {
    // const selectedAirline = data[0]?.AirSegments[0]?.AirlineCode;
    const searchPayload = {
      searchCriteria: params.searchCriteria,
      hasAir: params.hasAir,
      hasCar: params.hasCar,
      hasHotel: params.hasHotel,
      hasRail: params.hasRail,
      airRequestType: 0,
      // airClassType: airlistResponse[0]?.AirLegs[0]?.AirSegments[0]?.AirCabinClass,
      noofCar: 1,
      noofRooms: 1,
      adultCount: 1,
      IsGeoAutocomplete: false, //GR
      GooglePlace: {}, //GR
      isGeoSearch: false, //HT
      latitude: undefined, //HT
      longitude: undefined, //HT
      IsCarAutoComplete: undefined, //CR
      ServiceType: '',
    };

    //onSearchHandler(searchPayload, searchInputState);
  };

  const onSearchHandler = async (searchInput, searchInputState) => {
    const validationResult = validateTripSearch(searchInput);
    if (validationResult.isFailed) {
      dispatch(openAlert({ message: validationResult.msg }));
    } else {
      await dispatch(setSearchInput(searchInput, searchInputState));
      dispatch(tripSearch());
    }
  };

  return (
    <RebookHomeContext.Provider value={checkedPassengers}>
      <ScrollView showsVerticalScrollIndicator={false}>
        {passengers &&
          passengers.map((passenger, index) => {
            return (
              <View key={index} style={styles.passengerContainer}>
                <CheckboxSquare
                  label={passenger.FirstName}
                  value={checkedPassengers.find(
                    (ch) =>
                      ch.IROPPassengerKey === passenger.IROPPassengerKey && ch.isCheck === true
                  )}
                  onChange={(e) => handleCheckbox(e, passenger)}
                />
                <RowView>
                  <BaseText style={styles.passengerName}>
                    {moment(passenger.DOB).format('MMM DD, YYYY')}
                  </BaseText>
                  <BaseText style={styles.passengerName}>
                    {passenger.Gender == 'M' ? 'Male' : 'Female'}
                  </BaseText>
                </RowView>
              </View>
            );
          })}

        <View style={styles.rebookBox}>
          <RowView>
            <Icon name="warning" size={12} color={Color.primary} />
            <BaseText style={styles.confirmationText}>
              If you are traveling with a lap child, please contact the airline to add your child to
              the reservation.{' '}
            </BaseText>
          </RowView>
        </View>
        <View>
          {/* <TripSearchWidget onSearch={() => {}} loading={false} /> */}
          <TripSearchWidgetRebook
            onSearch={onSearchHandler}
            loading={searchTripLoading}
            isRebook={true}
          />

          {/* <SearchTypeCheckbox selected={true} iconName="flight" onPress={() => {}} /> */}

          {/* <TripSearchForm dispatch={dispatch} searchInputState={searchInputState} />
        <BaseText>No. of passengers : {checked.length}</BaseText>
        <View>
          <Button
            style={styles.submitButton}
            label="Search"
            labelStyle={CommonStyles.h2}
            loading={false}
            onPress={onSubmit}
          />
        </View> */}
        </View>
        <View style={styles.headingBottom}>
          <RebookFooter />
        </View>
      </ScrollView>
    </RebookHomeContext.Provider>
  );
};

const styles = StyleSheet.create({
  center: {
    justifyContent: 'center',
    alignItems: 'center',
    ...CommonProperties.p2,
  },
  headerLogoImg: {
    height: 35,
    width: 250,
    resizeMode: 'contain',
  },
  footer: {
    ...CommonProperties.p4,
    flex: 1,
  },
  passengerName: {
    ...CommonProperties.px3,
    ...CommonProperties.mt2,
    ...CommonProperties.ml5x,

    fontSize: FontSize.h3,
  },
  heading: {
    marginBottom: 60,
    alignItems: 'center',
    width: '115%',
    ...CommonProperties.p5,
    backgroundColor: Color.lightgray,
  },
  headingBottom: {
    marginTop: 10,
    alignItems: 'center',
    width: '100%',
    ...CommonProperties.p5,
    backgroundColor: Color.lightgray,
  },
  textHeading: {
    fontSize: FontSize.h1,
    fontWeight: '700',
  },
  frontierHeading: {
    fontSize: FontSize.h1,
    fontWeight: '500',
    color: Color.primary,
    ...CommonProperties.p3,
    ...CommonProperties.mt3,
  },
  confirmationText: {
    color: Color.primary,
    textAlign: 'center',
  },
  rebookBox: {
    backgroundColor: Color.accent,
    ...CommonProperties.p5,
    ...CommonProperties.mt3,
    ...CommonProperties.m2,
    ...CommonProperties.ml3,
    ...CommonProperties.mr3,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.6,
    shadowRadius: 4,
    elevation: 5,
  },
  submitButton: {
    ...CommonProperties.py3,
    ...CommonProperties.shadow,
    ...CommonProperties.borderRadius4,
  },
  rebookText: {
    fontSize: FontSize.h3,
    textAlign: 'center',
  },
  passengerContainer: {
    ...CommonProperties.p5,
    ...CommonProperties.mt3,
    ...CommonProperties.pl5,
    ...CommonProperties.ml3,
    ...CommonProperties.mr3,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.6,
    shadowRadius: 4,
    elevation: 5,
    justifyContent: 'center',
    alignItems: 'flex-start',
    borderWidth: 1,
    borderColor: Color.primary,
  },
  its: {
    flex: 4,
  },
});
export default RebookHomeScreen;
